import ModelUtil from '@leverege/model-util';
import DefaultSettingsModel from "../DefaultSettingsModel.js";
import SimpleImageThumbnailModel from "../SimpleImageThumbnailModel.js";
import SimpleImageDetailModel from "../SimpleImageDetailModel.js";
const TYPE = 'rsrc.Gallery';
function create(opts) {
  return {
    type: TYPE,
    thumbnail: {
      type: SimpleImageThumbnailModel.TYPE
    },
    detail: {
      type: SimpleImageDetailModel.TYPE
    },
    details: {
      ...DefaultSettingsModel
    }
  };
}
export default {
  id: TYPE,
  TYPE,
  create,
  ...ModelUtil.createAllValue('details', 'details'),
  ...ModelUtil.createAllValue('detail', 'detail'),
  ...ModelUtil.createAllValue('thumbnail', 'thumbnail')
};